import { HttpContextToken } from '@angular/common/http';

export const SKIP_AUTHENTICATION_REDIRECT = new HttpContextToken<boolean>(() => false);
